import AddContactToCompany from './AddContactToCompany'

export default AddContactToCompany
